import React from 'react';
import { DealRouteGuard } from '@/components/layouts/RecordRouteGuard/DealRouteGuard';
import { Box } from '@mui/material';
import CreateSOAForm from '@/components/forms/CreateSOAForm';

const DealSOAFormPage = () => {
	return (
		<DealRouteGuard>
			<Box padding={3}>
				<CreateSOAForm />
			</Box>
		</DealRouteGuard>
	);
};

export default DealSOAFormPage;
